// extracted by mini-css-extract-plugin
export var menuIcon = "_up-0";
export var menuIconInline = "_up-1";